import { getConvexPolygonArea } from "@the-real-insight/tri-model";

/**
 * Die Fläche eines Raums: aus dem gezeichneten Umriss (mm²), sonst die gespeicherte `floorArea` (m², aus
 * Import, BIM oder Raumbuch). Ein Raum ohne Umriss zeigte sonst „0.00“ oder „-“, obwohl seine Fläche bekannt ist.
 */
export const spaceAreaText = (space: { shape?: any; floorArea?: number | null }): string => {
  // Mongo hands the outline back as JSON text, the editor as an array.
  let shape = space.shape;
  if (typeof shape === "string") {
    try {
      shape = JSON.parse(shape);
    } catch {
      shape = null;
    }
  }
  const fromShape = Array.isArray(shape) && shape.length > 2 ? getConvexPolygonArea(shape) / 1000000 : 0;
  if (fromShape > 0) return fromShape.toFixed(2);
  return typeof space.floorArea === "number" && space.floorArea > 0 ? space.floorArea.toFixed(2) : "-";
};
